<template>
  <div class="container my-3">
    <div style="text-align: center">
      <loading :active.sync="carregando" :is-full-page="true"></loading>
    </div>

    <div :v-if="mensagemSucesso" v-for="i in mensagemSucesso" :key="i">
      <p>
        <b-alert show variant="success" dismissible>{{ i }}</b-alert>
      </p>
    </div>
    <div :v-if="mensagemErro" v-for="i in mensagemErro" :key="i">
      <p>
        <b-alert show variant="danger" dismissible>
          <b-icon variant="danger" icon="x-circle-fill" />
          {{ i }}
        </b-alert>
      </p>
    </div>

    <form @submit.prevent="uploadFile" enctype="multipart/form-data">
      <h2 class="title">Geração de DRAM por arquivo txt</h2>
      <b-card v-if="origemAcesso === 'AD' || origemAcesso === 'GovBr'">
        <h2 class="title">Anexe seu arquivo aqui</h2>
        <b-row class="mb-1 required">
          <b-col sm="10" align-self="end" class="mr-0 ml-0">
            <b-form-file
              v-model="file"
              accept=".txt"
              class="mb-4"
              ref="file-input"
              placeholder="Escolha um arquivo e anexe aqui..."
              @change="buscarArquivo()"
            ></b-form-file>
          </b-col>
        </b-row>

        <b-row class="mb-0">
          <b-col sm="12">
            <label for="email"
              >Endereço de e-mail para receber o link da(s) guia(s).</label
            >
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col sm="6" align-self="end" class="mr-0 ml-0">
            <b-form-input
              id="email"
              type="email"
              v-model="email"
              :disabled="true"
              placeholder="exemplo@exemplo.com.br"
            >
            </b-form-input>
          </b-col>
        </b-row>
        <b-row sm="2" class="mt-4 ml-5 required">
          <b-col>
            <small> preenchimento obrigatório </small>
          </b-col>
        </b-row>
        <b-row class="mt-2 float-right">
          <div>
            <b-button
              variant="outline-secondary"
              class="ml-3 mr-3"
              type="button"
              @click="limpar()"
            >
              Limpar
            </b-button>
          </div>
        </b-row>
        <b-row class="mt-2 mr-2 float-right">
          <div>
            <b-button
              variant="primary"
              class="ml-3 float-right"
              :disabled="habilitaCarregar != true || email == ''"
              type="submit"
            >
              Processar arquivo
            </b-button>
          </div>
        </b-row>
      </b-card>
    </form>

    <!-- lista guias a vista-->
    <div v-if="exibirListaGuia == true">
      <h2 class="title mt-5">Relação de Lançamentos Realizados</h2>
      <b-card class="mt-3">
        <tabelaGuiasLancamento :items="items" :fields="cabecalhoGuias" />
      </b-card>
    </div>
  </div>
</template>

<script>
import routes from "../routes/routes";
import loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import constantes from "@/constants";
import tabelaGuiasLancamento from "@/components/tabelaGuiasLancamento.vue";
import normalizaMensagemApi from '../helpers/normalizaMensagemApi';

export default {
  name: "FileUpload",

  data() {
    return {
      file: null,
      email: "",
      carregando: false,
      habilitaCarregar: false,
      exibirListaGuia: false,
      items: "",
      message: "",
      mensagemErro: [],
      mensagemSucesso: [],
      calculos: {
        OPCOES_PARCTO_CESSAO: [],
        OPCOES_PARCTO_DEMAIS: [],
        LANCAMENTO_CESSAO: [],
        LANCAMENTO_DEMAIS: [],
      },
      cabecalhoGuias: [
        {
          label: "Descrição",
          key: "DESCRICAO",
        },
        {
          label: "Numero da DRAM",
          key: "NUMEROGUIA",
          formatter: this.formatGuia,
        },
        {
          label: "Vencimento",
          key: "DATAVENCIMENTO",
          formatter: this.formatDateTime,
        },
        {
          label: "Valor total",
          key: "VALORTOTAL",
          formatter: this.formatCurrency,
        },
        {
          label: "Valor com desconto",
          key: "VALORDESCONTO",
          formatter: this.formatCurrency,
        },
        {
          label: "",
          key: "URLEMISSAO",
        },
        {
          label: "",
          key: "URLRELACAO",
        },
      ],
    };
  },

  components: {
    loading,
    tabelaGuiasLancamento,
  },

  async beforeMount() {
    this.file = null;
    this.origemAcesso = this.$store.getters.userInfo.origem;
    this.email = this.$store.getters.userInfo.email;
    if (this.origemAcesso !== "GovBr" || this.origemAcesso !== "AD")
      routes.push({ to: "Landing" });
    if (this.origemAcesso === "GovBr") {
      this.cadastroNacional = this.$store.getters.userInfo.preferred_username;
      this.nomeRazaoSocial = this.$store.getters.userInfo.name.toUpperCase();
    }
  },

  methods: {
   buscarArquivo() {
      //
      const valor = event.target.value;
      this.limparMensagens();
      this.habilitaCarregar = false;
      if (valor != null && valor != "") {
        if (valor.indexOf(".txt") == -1) {
          this.mensagemErro.push(
            "Arquivo inválido ! Permitido somente '.txt'."
          );
        } else {
          const arquivo = event.target.files[0];

          this.limparMensagens();
          this.habilitaCarregar = false;

          const reader = new FileReader();

          reader.onload = (e) => {
            const conteudo = e.target.result.trim();

            const linhas = conteudo.split(/\r?\n/);

            const linhasInvalidas = linhas.filter(
              (linha) => !/^\d{7}[A-Za-z0-9]{7}$/.test(linha.trim())
                //  ^: Indica o início da string.
                //  \d: Representa qualquer dígito (0-9).
                //  +: Indica que o dígito deve ocorrer uma ou mais vezes.
                //  $: Indica o final da string.
                //  7 primeiros caracteres: somente dígitos (\d{7})
                //  7 últimos caracteres: alfanuméricos ([A-Za-z0-9]{7})             
            );

            if (linhasInvalidas.length > 0) {
              this.mensagemErro.push(
                "Arquivo não pode ser carregado! A(s) linha(s) contém caracter(es) inválido(s):"
              );
              this.mensagemErro.push(linhasInvalidas.join(", "));
              this.file = null;
              this.$refs["file-input"].reset();
            } else {
              this.mensagemSucesso.push("Arquivo carregado com sucesso.");
              this.habilitaCarregar = true;
            }
          };

          reader.onerror = () => {
            alert("Erro ao ler o arquivo.");
          };

          reader.readAsText(arquivo);
        }
      }
    },

    limpar() {
      this.habilitaCarregar = false;
      this.limparMensagens();
      this.$refs["file-input"].reset();
    },

    limparMensagens() {
      this.mensagemSucesso = [];
      this.mensagemErro = [];
      this.fecharGuiasLancamento();
    },

    handleFileUpload() {
      this.file = event.target.files[0];
    },

    async uploadFile() {
      this.limparMensagens();
      this.carregando = true;
      const formData = new FormData();
      formData.append("file", this.file);
      formData.append(
        "matricula",
        this.$store.getters.userInfo.preferred_username.toUpperCase()
      );
      formData.append("email", this.email);

      try {
        await this.$axios
          .post(this.$env.url_backend + constantes.arquivoTXT, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.carregando = false;
            this.exibirListaGuia = false;
            if (response.status === 200) {
              this.mensagemSucesso.push(response.data.message);
            }
            if (response.status === 201) {
              this.mensagemSucesso.push(response.data.message); 
            }
          });
      } catch (error) {
        const mensagem = normalizaMensagemApi(error);
        this.mensagemErro.push(mensagem);
      } finally {
        this.carregando = false;
      }
    },

    fecharGuiasLancamento() {
      this.exibirListaGuia = false;
    },
  },
};
</script>

<style lang="css" scoped>
.required:before {
  font-size: 18px;
  color: red;
  content: "*";
  position: absolute;
  margin-left: 5px;
}
</style>
